"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXTronProvider = void 0;
const core_1 = require("@okxconnect/core");
class OKXTronProvider {
    constructor(provider) {
        this.TRON_CHAIN_ID = "tron:mainnet";
        this.provider = provider;
    }
    getChain(chainId) {
        if (chainId == null) {
            chainId = this.TRON_CHAIN_ID;
        }
        if (chainId != this.TRON_CHAIN_ID) {
            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.CHAIN_NOT_SUPPORTED, "The chainId:" + chainId + "is wrong for OKXTronProvider");
        }
        return chainId;
    }
    getAccount(chainId) {
        var _a, _b, _c, _d, _e;
        chainId = this.getChain(chainId);
        let account = (_b = (_a = this.provider.session) === null || _a === void 0 ? void 0 : _a.namespaces[core_1.NameSpaceKeyTron]) === null || _b === void 0 ? void 0 : _b.accounts.filter(function (account) {
            return account.startsWith(chainId);
        })[0];
        if (!account) {
            // if (required) {
            //      throw new Error('Account not found')
            // }
            return undefined;
        }
        const accountArray = account.split(':');
        const address = account.split(':')[2];
        let extra = (_e = (_d = (_c = this.provider.session) === null || _c === void 0 ? void 0 : _c.namespaces[core_1.NameSpaceKeyTron]) === null || _d === void 0 ? void 0 : _d.extra) === null || _e === void 0 ? void 0 : _e[(`${accountArray[0]}:${accountArray[1]}`)];
        let publicKey = "";
        if (extra != undefined) {
            publicKey = extra["publicKey"];
        }
        if (!address) {
            // if (required) {
            //     throw new Error('Address not found')
            // }
            return undefined;
        }
        return {
            address: address
        };
    }
    stringToHex(str) {
        let hex = '';
        for (let i = 0; i < str.length; i++) {
            hex += str.charCodeAt(i).toString(16).padStart(2, '0');
        }
        return hex;
    }
    signMessage(data, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            chainId = this.getChain(chainId);
            let signData = {
                "chainId": chainId,
                "method": "tron_signMessage",
                "params": {
                    "message": this.stringToHex(data)
                }
            };
            try {
                const ret = yield this.provider.request(signData, chainId);
                if ('result' in ret) {
                    return ret.result;
                }
                else {
                    let errorData = ret;
                    return errorData.error;
                }
            }
            catch (error) {
                return error;
                // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
    signMessageV2(data, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            chainId = this.getChain(chainId);
            let signData = {
                "chainId": chainId,
                "method": "tron_signMessageV2",
                "params": {
                    "message": data
                }
            };
            try {
                const ret = yield this.provider.request(signData, chainId);
                if ('result' in ret) {
                    return ret.result;
                }
                else {
                    let errorData = ret;
                    return errorData.error;
                }
            }
            catch (error) {
                return error;
                // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
    signTransaction(transaction, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            chainId = this.getChain(chainId);
            let data = {
                "method": "tron_signTransaction",
                "params": transaction
            };
            try {
                const ret = yield this.provider.request(data, chainId);
                if ('result' in ret) {
                    let signedTx;
                    if (typeof ret.result == "string") {
                        signedTx = JSON.parse(ret.result);
                    }
                    else {
                        signedTx = ret.result;
                    }
                    let realSignTx = {};
                    realSignTx.visible = signedTx.visible;
                    realSignTx.txID = signedTx.txID;
                    let rawData = {};
                    rawData.contract = signedTx.raw_data.contract;
                    rawData.expiration = signedTx.raw_data.expiration;
                    rawData.ref_block_bytes = signedTx.raw_data.ref_block_bytes;
                    rawData.fee_limit = signedTx.raw_data.fee_limit;
                    rawData.ref_block_hash = signedTx.raw_data.ref_block_hash;
                    rawData.timestamp = signedTx.raw_data.timestamp;
                    realSignTx.raw_data = rawData;
                    realSignTx.raw_data_hex = signedTx.raw_data_hex;
                    realSignTx.signature = signedTx.signature;
                    return realSignTx;
                }
            }
            catch (error) {
                return error;
                // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
    signAndSendTransaction(transaction, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            chainId = this.getChain(chainId);
            let data = {
                "method": "tron_signAndSendTransaction",
                "params": transaction
            };
            try {
                const ret = yield this.provider.request(data, chainId);
                if ('result' in ret) {
                    return ret.result;
                }
            }
            catch (error) {
                return error;
                // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
}
exports.OKXTronProvider = OKXTronProvider;
